interface Location {
  name: string;
  logoPath: string;
  contactName?: string;
  address?: string;
  phone?: string;
}

export const appConfig = {
  company: {
    name: 'RAISE Tours',
    logoPath: 'v1/public/logos/og_logo.png',
    tagline: "Creating unforgettable travel experiences to the world's most incredible destinations. Your journey to the extraordinary begins here.",
    whatsappGroupLink: 'https://chat.whatsapp.com/HBYVKVwIlmcKSHbddtgKuw'
  },
  admin: {
    username: 'admin',
    password: 'raise2025',
  },
  contact: {
    phone: '+91 9448073129',
    email: 'raiseinfo@gmail.com',
    address: {
      line1: 'Narasimha, 1st Floor, ',
      line2: 'Dr Shivakumaraswamiji Circle',
      line3: 'Tumkur - 572102',
      country: 'India',
    },
  },
  links: {
    privacyPolicy: '/privacy-policy',
    termsOfService: '/terms-of-service',
    refundPolicy: '/refund-policy',
    cancellationPolicy: '/cancellation-policy',
  },
  metrics: {
    happyTravelers: 20000,
    destinationCount: 80,
    averageRating: 5,
    establishedYear: 2012,
  },
  about: {
    name: 'Mr. T.V.N. Murthy',
    description: 'An avid traveler, photographer, and trainer, Mr. T.V.N. Murthy founded RAISE after exploring more than 129 countries. With a background in Automobile Engineering and deep knowledge of ecology, environment, and ornithology, he brings wisdom, creativity, and compassion to every journey.',
    image: 'v1/public/images/about/tvn.jpg',
    about: 'Mr. Murthy served as the Honorary Wildlife Warden of Tumkur District for 15 years and is a visiting faculty member for hospitality courses. His love for photography turns every journey into a visual masterpiece. \n\n A passionate trainer and speaker, he led Junior Chamber International (JCI) India as National President in 2005. He regularly appears on TV to speak about travel and wildlife. \n\n He also founded the Wildlife Aware Nature Club and actively mentors young nature enthusiasts.',
  },
  social: {
    facebook: 'https://www.facebook.com/murthytvn',
    instagram: 'https://www.instagram.com/raise_tours/', // Add Instagram URL here
    youtube: 'https://www.youtube.com/@raiseinfo', // Add YouTube URL here
    whatsapp: 'https://wa.me/919448073129', // Add WhatsApp link here
  },
  slideshow: {
    slideDuration: 5000, // 5 seconds in milliseconds
  },
  video: {
    introUrl: 'https://youtu.be/Hk1wu_ZEAYU?si=BrCUO6Bv-njaA4AX',
  },
  fallbackLogos: [
    '/logos/gray_logo.png',
    '/logos/lime_green_logo.png',
    '/logos/purple_logo.png',
    '/logos/teal_logo.png',
  ],
  locations: [
    {
      name: 'Tumkur',
      logoPath: '/logos/purple_logo.png',
      contactName: 'Mr. T.V.N. Murthy',
      address: 'Narasimha, 1st Floor, Dr Shivakumaraswamiji Circle, Tumkur - 572102',
      phone: '+91 9448073129',
    },
    {
      name: 'Coorg',
      logoPath: '/logos/teal_logo.png',
      contactName: 'Dr. Kiran',
      address: '',
      phone: '+91 94481 08104',
    },
    {
      name: 'Davanagere',
      logoPath: '/logos/mothi_international.jpg',
      contactName: 'Mrs. Bhavani Guruprasad',
      address: 'Door No 353 Sri Gouri Nivas Nijalingappa Layout, 2nd Main Near Laxmi Floor Mills, Davanagere - 577004',
      phone: '+91 94499 84859',
    },
    {
      name: 'Mumbai',
      logoPath: '/logos/lime_green_logo.png',
      contactName: 'Mrs. Sanjeeta Puthran',
      address: '',
      phone: '+91 98923 05436',
    },
    
  ] as Location[],
};

export type AppConfig = typeof appConfig;
export type { Location };


